<template>
  <div class='subdomain-node-properties'>
    <div class='subdomain-node-properties__header'>
      <div>
        <v-icon>dns</v-icon>
      </div>
      <div class='subdomain-node-properties__header__title'>
        <div class='subdomain-node-properties__header__title__name'>
          {{name}}
        </div>
        <div class='subdomain-node-properties__header__title__type'>
          {{$t(`ctc.properties.type.${data.type.toLowerCase()}`)}}
        </div>
      </div>
    </div>
    <v-expansion-panels multiple v-model="panels" flat>
      <!-- IPs Panel -->
      <v-expansion-panel>
        <v-expansion-panel-header class='panel-header'>{{$t('ctc.properties.ips.title')}}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="ips-content" v-if="data.ips && data.ips.length">
            <div class="ip-row" v-for="(ip, index) in data.ips" :key="index">
              <div class="ip-value">{{ip}}</div>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
export default {
  name: 'SubdomainNodeProperties',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      panels: [0],
    };
  },
  computed: {
    name() {
      return this.data.name;
    },
  },
};
</script>
<style scoped lang='scss'>
@import '~@/assets/styles/design-system';
.subdomain-node-properties{
  display: flex;
  flex-direction: column;
  margin-top: rem(15);
  &__header{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-left: rem(10);
    &__title{
      display: flex;
      flex-direction: column;
      margin-left: rem(15);
      &__name{
        color: var(--text-primary);
        font-family: $font-family-regular;
        font-size: rem(16);
        font-weight: bold;
        letter-spacing: 0;
        line-height: rem(17);
        word-wrap: break-word;
        max-width: rem(240);
      };
      &__type{
        color: var(--text-tertiary);
        font-family: $font-family-regular;
        font-size: rem(10);
        letter-spacing: 1.1px;
        line-height: rem(15);
        margin-top: rem(5);
        text-transform: uppercase;
      };
    };
  }
  .panel-header {
    color: var(--text-primary);
    font-family: $font-family-medium;
    font-size: rem(14);
    letter-spacing: 0;
    line-height: rem(17);
    text-transform: uppercase;
  }
  .ips-content {
    padding: rem(10);
  }
  .ip-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: rem(8);
  }
  .ip-value {
    color: var(--text-primary);
    font-family: $font-family-regular;
    font-size: rem(10);
    align-items: center;
  }
}
</style>
